import { displayNewAppointmentForm } from './displayNewAppointmentForm';
import displayNewMessageForm from './displayNewMessageForm';
import displayReplyForm from './displayReplyFormAdapter';
import {
    addCategoriesMailbox,
    removeCategoriesMailbox,
    getCategoriesMailbox,
    getCategoriesItem,
    addCategoriesItemRead,
    removeCategoriesItemRead,
} from '../common/categoriesAdapter';
import checkItemId from '../common/checkItemIdAdapter';
import { displayAppointmentForm } from '../common/displayAppointmentFormAdapter';
import displayMessageForm from '../common/displayMessageFormAdapter';
import { getRecurrence, getSeriesIdRead } from '../common/recurrenceAdapter';
import { isRemoteItem, isSharedItem } from '../common/sharedItemAdapter';
import { getSharedProperties } from '../common/sharedPropertiesAdapter';
import { closeTaskPane, openTaskPane } from '../common/taskPaneAdapter';
import { getReadHostItemIndex, AppointmentReadAdapter } from 'owa-addins-core';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { ReadingPaneState } from 'owa-calendar-reading-pane-store/lib/store/schema/ReadingPaneState';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    addNotificationMessage,
    removeNotificationMessage,
    getNotificationMessageIds,
} from '../notifications/notificationsAdapter';
import { getEnhancedLocations } from '../common/getEnhancedLocationsAdapter';
import { getAttachmentContent } from '../read/readAttachmentAdapter';

let getItemId = (eventId: string) => () => {
    return eventId;
};

let isAddinPinned = (addinId: string): boolean => {
    return false;
};

export default function createAppointmentReadAdapter(
    event: CalendarEvent,
    viewState: ReadingPaneState
): AppointmentReadAdapter {
    const eventId = event.ItemId.Id;

    return {
        getItem: () => event as any,
        getItemId: getItemId(eventId),
        mode: ExtensibilityModeEnum.AppointmentAttendee,
        displayReplyForm: displayReplyForm(event),
        isAddinPinned,
        addNotificationMessage: addNotificationMessage(
            getReadHostItemIndex(eventId),
            viewState,
            eventId
        ),
        removeNotificationMessage: removeNotificationMessage(viewState, eventId),
        getNotificationMessageIds: getNotificationMessageIds(viewState),
        displayNewMessageForm: displayNewMessageForm,
        checkItemId,
        displayMessageForm,
        openTaskPane: openTaskPane(ExtensibilityModeEnum.AppointmentAttendee),
        closeTaskPane: closeTaskPane(ExtensibilityModeEnum.AppointmentAttendee),
        displayNewAppointmentForm: displayNewAppointmentForm(event),
        displayAppointmentForm: displayAppointmentForm,
        isSharedItem: isSharedItem(event),
        isRemoteItem: isRemoteItem(event),
        getRecurrence: getRecurrence(event),
        getSeriesId: getSeriesIdRead(event),
        getSharedProperties: getSharedProperties(event),
        getEnhancedLocations: getEnhancedLocations(event),
        getAttachmentContent: getAttachmentContent(viewState),
        getCategoriesMailbox: getCategoriesMailbox(event),
        addCategoriesMailbox: addCategoriesMailbox,
        removeCategoriesMailbox: removeCategoriesMailbox,
        getCategoriesItem: getCategoriesItem(event),
        addCategoriesItemRead: addCategoriesItemRead(event),
        removeCategoriesItemRead: removeCategoriesItemRead(event),
    };
}
